import React from 'react';
import { commonMenu } from './commonMenu';
import NavItem from './NavItem';
import {
  PaymentsIcon,
  Magaphone2Icon,
  CalendarIcon,
  TicketIcon,
  ClientsIcon,
} from 'assets/icons';

interface FinanceMenuProps {
  isTaxExpanded: boolean;
  setIsTaxExpanded: React.Dispatch<React.SetStateAction<boolean>>;
  isFinCenExpanded: boolean;
  setIsFinCenExpanded: React.Dispatch<React.SetStateAction<boolean>>;
  handleToggle: (
    setter: React.Dispatch<React.SetStateAction<boolean>>,
  ) => (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
}

/**
 * Sidebar shown to Admins / Accountants who belong to the
 * “Finance Back Office” department.
 */
export default function FinanceMenu(props: FinanceMenuProps) {
  return (
    <>
      {/* dashboard, tasks, tax, services, ai‑mito, messages, privacy‑policy */}
      {commonMenu({
        ...props,
        taxReturnsPath: '/dashboard/taxReturns',
        showServices: true,
      })}

      {/* promo codes, announcements, upcoming dates, tickets */}
      <NavItem
        icon={PaymentsIcon}
        name="Promo Codes"
        path="/dashboard/promocodes"
        className="custom-menu-item"
      />
      <NavItem
        icon={ClientsIcon}
        name="Clients"
        path="/dashboard/clients"
        className="custom-menu-item"
      />
      <NavItem
        icon={Magaphone2Icon}
        name="Announcements"
        path="/dashboard/announcements"
        className="custom-menu-item"
      />
      <NavItem
        icon={CalendarIcon}
        name="Upcoming Dates"
        path="/dashboard/upcomingDates"
        className="custom-menu-item"
      />
      <NavItem
        icon={TicketIcon}
        name="Tickets"
        path="/dashboard/tickets"
        className="custom-menu-item"
      />
    </>
  );
}
